import { useQuery } from "@tanstack/react-query"
import { useCurrentOrganization } from "@/modules/organizations/hooks/use-organizations"
import { resourceAccessService } from "../infrastructure/resource-access-service"
import { ResourceAssigneeDto, ResourceType } from "../dtos/ResourceAccessDtos"

/**
 * Assignees for every restricted record of a type the caller can see, keyed by resourceId — for
 * decorating list pages (an "Assigned" column, an avatar stack) without an N+1 request per row.
 */
export function useResourceAssigneesForList(type: ResourceType) {
  const org = useCurrentOrganization()
  const orgId = org?.id ?? ""

  const query = useQuery({
    queryKey: ["resource-assignees-for-list", orgId, type],
    queryFn: () => resourceAccessService.getAssigneesForList(orgId, type),
    enabled: !!orgId,
  })

  const byResourceId = new Map<string, ResourceAssigneeDto[]>(
    (query.data ?? []).map((row) => [row.resourceId, row.assignees]),
  )

  return { ...query, byResourceId }
}
